import { render, staticRenderFns } from "./HeroIcon.vue?vue&type=template&id=f8174c5c"
import script from "./HeroIcon.vue?vue&type=script&lang=js"
export * from "./HeroIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports